<template>
  <div>
    <ManageGameListTab />
  </div>
</template>

<script>
import ManageGameListTab from './components/ManageGameListTab.vue'

export default {
  name: 'GameListManage',
  components: {
    ManageGameListTab,
  },
}
</script>

<style scoped></style>
